import { Component, OnInit, AfterViewInit, OnDestroy, Input } from '@angular/core';
import { StarbaseSearchComponent, IStarbaseModularSearchField, TrackByUID, FilterParams } from 'starbase-launcher';
import { LU_Keyword } from '../models/keyword';
import { KeywordDataService } from '../services/keyword-data.service';
import { Observable, Subscription, of, Subject } from 'rxjs';
import { LookupDataService } from '../services/lookup-data.service';
import { switchMap, mergeMap, takeUntil, catchError, finalize } from 'rxjs/operators';

@Component({
  selector: 'app-keyword-search',
  templateUrl: './keyword-search.component.html',
  styleUrls: ['./keyword-search.component.css']
})
export class KeywordSearchComponent extends StarbaseSearchComponent<LU_Keyword> implements OnInit, AfterViewInit, OnDestroy {
  @Input() placeholderText = 'Search Keywords...';

  trackByUID = TrackByUID;
  loading = false;
  loadingNextPage = false;

  protected modularSearchFields: IStarbaseModularSearchField<LU_Keyword>[] = [
    {
      displayName: 'Active',
      fieldName: 'Active',
      default: true,
      enabled: true,
      filterClause: (k: LU_Keyword, searchChars: string) => k && k.keyword && k.active
    }
  ];

  private filterParams: FilterParams<LU_Keyword>;

  private cancel$ = new Subject<void>();


  constructor(private keywordSvc: KeywordDataService, private typeSvc: LookupDataService) {
    super();
    this.filterParams = new FilterParams<LU_Keyword>();
    this.filterParams.addToSorts('Appears');
    this.filterParams.addToSorts('Keyword');
    this.filterParams.sortAsc = false;
    this.configLocked = true;
   }

  ngOnInit() {
    this.hadText = false;
    super.ngOnInit();
  }
  ngAfterViewInit() {
    super.ngAfterViewInit();
  }
  ngOnDestroy() {
    this.cancel$.next();
    this.cancel$.complete();
    super.ngOnDestroy();
  }

  outputModel(c: LU_Keyword) {
    super.outputModel(c);
    this.clearEvent();
    this.triggerFocus();
  }

  clearEvent(): void {
    this.cancel$.next();
    this.hadText = false;
    super.clearEvent();
  }

  public setTextToDisplay: (k: LU_Keyword) => string = (k: LU_Keyword) => k.keyword || 'ERROR';

  protected runSearch(searchChars: string): Observable<LU_Keyword[]> {
    console.log('Searching Keywords for ' + searchChars);
    try {
      if (searchChars === '') {
        this.hadText = false;
        this.cancel$.next();
        return of(this.dataToShow);
      }
      this.hadText = true;

      this.filterParams.searchPhrase = searchChars;
      this.filterParams.rpp = 50;
      this.filterParams.page = 1;
      const searchFilters = this.enabledModularFilters();
      return this.keywordSvc.getDataByFilterParamsBroadSearch(undefined, this.filterParams).pipe(
        switchMap(d => {
          this.filterParams = d;
          this.data = d.collection;
          this.dataToShow = this.data.filter(v => searchFilters.some(f => f.filterClause(v, searchChars)));
          return [this.dataToShow];
        }),
        takeUntil(this.cancel$),
        catchError((e) => {
          throw e;
        }),
        finalize(() => this.loading = false)
      );
    } catch (e) {
      console.error(e);
      this.errorOutput.emit();
      return of([]);
    }
  }

  protected loadNextPage(index: number) {
    // eslint-disable-next-line max-len
    if (this.filterParams.page < this.filterParams.totalPages && index > (this.dataToShow.length - 5) && !this.loadingNextPage) {
      const searchFilters = this.enabledModularFilters();
      this.loadingNextPage = true;
      this.filterParams.page += 1;
      this.keywordSvc.getDataByFilterParamsBroadSearch(undefined, this.filterParams).subscribe(d => {
        this.filterParams = d;
        this.data = [...this.data, ...d.collection];
        this.dataToShow = this.data.filter(v => searchFilters.some(f => f.filterClause(v, this.filterParams.searchPhrase)));
        this.loadingNextPage = false;
        return [this.dataToShow];
      }, (e) => {
        console.error(e);
      });
    }
  }
}
